import styled from 'styled-components'

const Header = styled.div`
    box-shadow: 0 -4px 5px 0px #00000014 !important;
`

const ContentContainer = styled.div`
    height: calc(100% - 50px);
`

const Count = styled.span`
    font-size: 12px;
    font-weight: 700;
    border-radius: 5px;
    width: 18px;
    height: 18px;
    text-align: center;
    color: white;
    background-color: #f84f7f;
    margin-left: 5px;
`

export { 
    Header,
    ContentContainer,
    Count
}